import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { ProcedureCategory } from '../types/procedure';

type GetProcedureCategoriesResponse = {
    procedureCategories: ProcedureCategory[];
};

type UseProcedureCategoriesConfig = {
    search?: string;
};

async function getProcedureCategories(
    templateId: string,
    { search }: UseProcedureCategoriesConfig
): Promise<GetProcedureCategoriesResponse> {
    const query = `?search=${search}`;
    const { data } = await api.get(`/procedures/templates/${templateId}/categories${query}`);
    return data;
}

export function useProcedureCategories(
    templateId: string,
    { search }: UseProcedureCategoriesConfig
): UseQueryResult<GetProcedureCategoriesResponse, unknown> {
    return useQuery(['procedure-categories', templateId, search], () => getProcedureCategories(templateId, { search }), {
        keepPreviousData: true,
        enabled: Boolean(templateId) && search !== undefined,
    });
}
